<template>
  <!-- Toggle Sidebar Button -->
  <div class="mobile-toggle-button-wrapper">
    <div class="mobile-toggle-button" @click="toggleSidebar">
      <i class="fas fa-chevron-right icon-style fa-lg" style="margin-bottom: 12px;"></i>
</div>

  <!-- Profile Sidebar -->
  <div class="profile-sidebar" :class="{ 'open': isSidebarOpen }">
    <div class="widget-profile pro-widget-content" style="border: none; background-color: #f8f8f8; margin: 0;">
      <div class="profile-info-widget">
        <router-link class="booking-doc-img" to="/patient/profile">
          <img v-bind:src="user_image
              ? config.base_url_for_Image + user_image
              : loadImg('Patient Profile.svg')
            " alt="User Image" />
        </router-link>
        <div class="profile-det-info">
          <h3>{{ this.username }}</h3>
          <div class="patient-details">
            <h5><i class="fas fa-birthday-cake"></i>{{this.dob}}</h5>
            <h5><i class="fas fa-heart"></i> {{ this.age }}</h5>
            <h5 class="mb-0">
              <i class="fas fa-map-marker-alt"></i> {{ this.city }}
            </h5>
            <div class="upload-img">
              <div class="change-photo-btn" style="margin-top: 10px;">
                <span>
                  <i class="fa fa-upload"></i>
                  {{ user_image ? 'Change' : 'Upload' }}
                </span>
                <input type="file" class="upload" accept="image/*" @change="onFileChange" />
              </div>
              <small class="form-text text-muted mt-2" style="text-align: center;"
                                >Allowed JPG, GIF or PNG. Max size: 2MB</small
                              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-widget">
      <nav class="dashboard-menu" style="background-color: #f8f8f8;">
        <ul>
          <!-- <li :class="currentPath == 'onboarding' ? 'active' : 'notaactive'
            ">
            <router-link to="/patient/index">
              <i class="fas fa-tasks"></i>
              <span>Onboarding</span>
            </router-link>
          </li> -->
          <li :class="currentPath == 'patient-dashboard' ? 'active' : 'notaactive'
            ">

            <router-link to="/patient/index">
              <i class="fas fa-tachometer-alt"></i>
              <span>Dashboard</span>
            </router-link>
          </li>
          <li :class="currentPath == 'favourites' ? 'active' : 'notaactive'">
            <router-link to="/patient/favourites">
              <i class="fas fa-user-md"></i>
              <span>My Doctors</span>
            </router-link>
          </li>
          <li :class="currentPath == 'dependent' ? 'active' : 'notaactive'">
            <router-link to="/patient/dependent">
              <i class="fas fa-user-friends"></i>
              <span>My Family</span>
            </router-link>
          </li>
          <li :class="currentPath == 'my-encounter' ? 'active' : 'notaactive'">
            <router-link to="/patient/my-encounter">
              <i class="fas fa-clinic-medical"></i>
              <span>Doctor Visits</span>
            </router-link>
          </li>
          <li :class="currentPath == 'medical-records' ? 'active' : 'notaactive'">
            <router-link to="/patient/medical-records">
              <i class="fas fa-history"></i>
              <span>Medication History</span>
            </router-link>
          </li>
          <li :class="currentPath == 'receipt' ? 'active': 'notactive'">
            <router-link to="/patient/receipt">
              <i class="fas fa-receipt"></i>
              <span>Fee Payments</span>
            </router-link>
          </li>
          <!-- <li :class="currentPath == 'patient-testimonial' ? 'active' : 'notaactive'
            ">
            <router-link to="/patient/testimonial">
              <i class="fas fa-comment-medical"></i>
              <span>Doctor Reviews</span>
            </router-link>
          </li> -->
          <li :class="currentPath == 'patient-profile-settings'
              ? 'active'
              : 'notaactive'
            ">
            <router-link to="/patient/profile">
              <i class="fas fa-user-cog"></i>
              <span>Profile</span>
            </router-link>
          </li>
          <li :class="currentPath == 'patient-change-password' ? 'active' : 'notaactive'
            ">
            <!-- <a
              href="javascr:void(0);"
              @click="navigate('/patient/change-password')"
            >
              <i class="fas fa-lock"></i>
              <span>Change Password</span>
            </a> -->
          </li>
          <li>
            <!-- <router-link to="/index">
                                <i class="fas fa-sign-out-alt"></i>
                                <span>Logout</span>
                            </router-link> -->
            <a href="javascript:void(0);" @click="submit_logout" class="dropdown-item"><i
                class="fas fa-sign-out-alt"></i><span>Logout</span></a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
  <!-- /Profile Sidebar -->
</template>

<script>
import { mapActions } from "vuex";
import config from "../../../services/CommonApi";

import CommonApi from "../../../services/CommonApi";
const images = require.context("@/assets/img/patients");
export default {
  data() {
    return {
      isSidebarOpen: false,
      username: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).username
        : null,
      user_image: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).image
        : null,
      dob:
        localStorage.getItem("userInfo").dob !== null
          ? JSON.parse(localStorage.getItem("userInfo")).dob
          : "",

      update_dob:
      localStorage.getItem("update_dob"),
      age:
        localStorage.getItem("userInfo").age !== null
          ? JSON.parse(localStorage.getItem("userInfo")).age
          : "",
      city:
        localStorage.getItem("userInfo").city !== null
          ? JSON.parse(localStorage.getItem("userInfo")).city
          : "-",
      config: config,
    };
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
  },
  methods: {

    toggleSidebar() {
  this.isSidebarOpen = !this.isSidebarOpen; // Toggle the variable
},
    ...mapActions(["signOut"]),

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    navigate(url) {
      this.$router.push(url);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    /* Get Profile Image */
    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    /* Change Profile Image */
    onFileChange(e) {
      var files = e.target.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    /* Create Profile Image */
    createImage(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.update_patient_profile(file.name, e.target.result);
      };
      reader.readAsDataURL(file);
    },

    /* Upload Image API */
    async update_patient_profile(filename, upload_image) {
      this.$swal({
        text: "Updating Profile Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        patient: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.profile_photo_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          const retrievedString = localStorage.getItem("userInfo");
          const parsedObject = JSON.parse(retrievedString);
          parsedObject.image = res.data;
          const strigifiedForStorage = JSON.stringify(parsedObject);
          localStorage.setItem("userInfo", strigifiedForStorage);
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
        }
      });
    },



    async submit_logout() {
      this.signOut();
      this.$store.dispatch("user/setUserType");
      this.$store.dispatch("user/setUserID");
    },
  },
};
</script>

<style>
  /* CSS for desktop view (default) */
  .profile-sidebar {
    display: block; /* Always open in desktop view */
  }

  /* Style for hidden sidebar in desktop view */
  .icon-style {
  position: absolute;
  left: -9999px;
}

@media (max-width: 768px) {
  .icon-style {
    position: static;
    left: auto;
  }
}

  /* CSS for mobile view (screen width less than 768px, adjust as needed) */
  @media (max-width: 768px) {
    .mobile-toggle-button-wrapper {
      display: block; /* Show the button in mobile view */
    }

    /* Style for hidden sidebar in mobile view */
    .profile-sidebar {
      display: none;
    }

    /* Style for open sidebar in mobile view */
    .profile-sidebar.open {
      display: block;
    }

    /* Style the elements with "icon-style" in mobile view */
    .icon-style {
      /* Add your desired styles here */
    }
  }
   /* CSS for desktop view (screen width greater than 768px) */
   @media (min-width: 768px) {
    .widget-profile {
      display: block;
    }
  }

  /* CSS for mobile view (screen width up to 768px) */
  @media (max-width: 768px) {
    .widget-profile {
      display: none; 
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/layouts/patient/SideBar.vue